import {
  MediaQuery,
  H3Heavy,
  CopyButton,
  CouponStamp,
  H1Heavy,
  Button,
  BodyHeavy,
  Caption,
  CaptionHeavy,
  Colors,
} from '@pelando/components';
import styled, { css } from 'styled-components';

export interface StampProps {
  isExpiredCoupon: boolean;
}

export const ModalCouponSubtitleExpiredCoupon = styled.p`
  ${Caption}
  color: rgb(${Colors.Gray});
  text-align: center;
  text-decoration: none;
  margin-bottom: 8px;
`;

export const ModalCouponTitle = styled.p`
  ${BodyHeavy}
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: rgb(${({ theme }) => theme.colors.Alpha});
  text-align: left;
  text-decoration: none;

  @media ${MediaQuery.SCREEN_MD_UP} {
    ${H3Heavy}
  }
`;

export const ModalCopyButton = styled(CopyButton)`
  margin-bottom: 12px;
  width: 100%;
`;

export const ModalButton = styled(Button)`
  margin-bottom: 8px;
  width: 100%;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ModalLink = styled.div`
  ${CaptionHeavy}
  color: rgb(${({ theme }) => theme.colors.Alpha});
  cursor: pointer;
  text-decoration: underline;
`;

export const ModalCouponStamp = styled(CouponStamp)<StampProps>`
  ${H1Heavy}

  margin-right: 12px;
  padding: 4px 12px;

  color: rgb(
    ${({ theme, isExpiredCoupon }) =>
      isExpiredCoupon ? theme.colors.Alpha : theme.colors.Brand}
  );

  small {
    ${H3Heavy}
  }

  span {
    line-height: 32px;
  }

  @media ${MediaQuery.SCREEN_MD_UP} {
    padding: 4px;
    line-height: 32px;
  }
`;

export const modalContainerStyle = css`
  padding: 16px 16px 24px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    max-width: 375px;
  }
`;
